module.exports = __webpack_public_path__ + "static/media/facebookbanner.497e65c8.png";